module.exports = __webpack_public_path__ + "fonts/la-regular-400.aa859c0.woff";